module.exports = __webpack_public_path__ + "static/img/pricing_img-1.f5a633e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pricing_img-1.png
// module id = BqLY
// module chunks = 0